// extracted by mini-css-extract-plugin
export var deleteModal = "_sv-0";